import React, { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import CalendarDay from './CalendarDay';
import { getMonthDays, WEEKDAYS } from './calendarUtils';
import './CalendarView.scss';

const CalendarGrid = ({ currentDate, tasks, notes = [], onTaskClick, onCreateTask, projectId, dateRange, filters, colorCodeOption }) => {
  const days = useMemo(() => getMonthDays(currentDate), [currentDate]);
  const [activeMenuDate, setActiveMenuDate] = useState(null);

  const tasksByDate = useMemo(() => {
    const map = {};
    tasks.forEach(task => {
      if (task.startDate) {
        const dateKey = task.startDate;
        if (!map[dateKey]) {
          map[dateKey] = [];
        }
        map[dateKey].push(task);
      }
    });
    return map;
  }, [tasks]);

  const notesByDate = useMemo(() => {
    const map = {};
    notes.forEach(note => {
      if (note.date) {
        if (!map[note.date]) {
          map[note.date] = [];
        }
        map[note.date].push(note);
      }
    });
    return map;
  }, [notes]);

  return (
    <Box className="calendar-content" sx={{ position: 'relative' }}>
      <Box className="calendar-weekdays">
        {WEEKDAYS.map((day, index) => (
          <Box key={index} className="calendar-weekday">
            {day}
          </Box>
        ))}
      </Box>
      
      <Box className="calendar-days-grid">
        {days.map((day, index) => (
          <CalendarDay
            key={index}
            day={day}
            tasks={tasksByDate[day.dateString] || []}
            note={notesByDate[day.dateString] || []}
            onTaskClick={onTaskClick}
            activeMenuDate={activeMenuDate}
            setActiveMenuDate={setActiveMenuDate}
            onCreateTask={onCreateTask}
            projectId={projectId}
            dateRange={dateRange}
            filters={filters}
            colorCodeOption={colorCodeOption}
          />
        ))}
      </Box>
    </Box>
  );
};

export default CalendarGrid;
